module.exports = __webpack_public_path__ + "img/quest_icon_0074_upgrade.997a3481.png";